module.exports = __webpack_public_path__ + "static/img/BFM.fe090ac3.svg";